import { GetApiData } from './fetchConfig';

export const useSections = () => GetApiData('sections');